import { Selector } from '@ngxs/store';
import { MessengerState } from './messenger.state';
import { IChatMessage, IFilterState, IMachineMessage, IMessengerStateModel } from '../../interfaces/messenger';
import { IMachineTracking } from '../../interfaces/signal-r/machine-tracking';

export class MessengerSelector {
  @Selector([MessengerState])
  static messages(state: IMessengerStateModel): IMachineMessage[] {
    return state.messages;
  }

  @Selector([MessengerState])
  static unreadMessages(state: IMessengerStateModel): IMachineMessage[] {
    return state.unreadMessages;
  }

  @Selector([MessengerState])
  static activeMessage(state: IMessengerStateModel): IMachineMessage {
    return state.activeMessage;
  }

  @Selector([MessengerState])
  static isChatLoading(state: IMessengerStateModel): boolean {
    return state.isChatLoading;
  }

  @Selector([MessengerState])
  static isSendingMessage(state: IMessengerStateModel): boolean {
    return state.isSendingMessage;
  }

  @Selector([MessengerState])
  static messengerFilter(state: IMessengerStateModel): IFilterState {
    return state.messengerFilter;
  }

  @Selector([MessengerState])
  static messageUpdated(state: IMessengerStateModel): IChatMessage {
    return state.messageUpdated;
  }

  @Selector([MessengerState])
  static newTracking(state: IMessengerStateModel): IMachineTracking {
    return state.newTracking;
  }

  @Selector([MessengerState])
  static isCheckingMessages(state: IMessengerStateModel): boolean {
    return state.isCheckingMessages;
  }

  @Selector([MessengerState])
  static messagesChecked(state: IMessengerStateModel): boolean {
    return state.messagesChecked;
  }

  @Selector([MessengerState])
  static isGlobalMessageOpen(state: IMessengerStateModel): boolean {
    return state.isGlobalMessageOpen;
  }

  @Selector([MessengerState])
  static sidebarNotification(state: IMessengerStateModel): number {
    return state.sidebarNotification;
  }
}
